// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2TvtB","info":"PatientInfo_info__2xqCz"};